import { utils } from '@yola/ws-sdk';
import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';
import settingIds from '../../constants/setting-ids';

const RESTRICTED_VALUE = 32;
const FALLBACK_VALUE = '40px';

const convert = (attributeValue) => {
  let value = FALLBACK_VALUE;

  if (attributeValue !== true && attributeValue !== '' && attributeValue != null) {
    const parsedValue = parseFloat(attributeValue);

    if (utils.isNumeric(parsedValue)) {
      value = `${parsedValue}px`;
    }
  }

  const values = { [breakpointKeys.DEFAULT]: value };

  if (parseFloat(value) > RESTRICTED_VALUE) {
    values[breakpointKeys.MAX_XL] = `${RESTRICTED_VALUE}px`;
  }

  return values;
};

export default [
  {
    scope: settingIds.THIS_COLUMN,
    attribute: targetAttributes.PADDING_LEFT,
    classes: [targetClasses.COL_PADDING_LEFT],
    convert,
  },
  {
    scope: settingIds.THIS_COLUMN,
    attribute: targetAttributes.PADDING_RIGHT,
    classes: [targetClasses.COL_PADDING_RIGHT],
    convert,
  },
];
